import api from '@/services/api2.service';


class TranscriptService {
    
    getTranscriptList(token){
        return api
            .get('/transcripts', { 
                headers: { 
                    Authorization: token
                } 
            });
    }

    deleteTranscript(conference_id, token) {
        return api
            .delete(`/transcript/${conference_id}`, {
                headers: {
                    Authorization: token
                }
            });
    }

    getTranscript(conference_id, token) {
        return api
            .get(`/transcript/${conference_id}`, {
                headers: {
                    Authorization: token
                }
            });
    }

    getSharedTranscript(conference_id) {
        return api
            .get(`/transcript/shared/${conference_id}`, {
            });
    }

    updateTranscript(transcript, token) {
        console.log(transcript)
        return api
            .patch(`/transcript/${transcript.id}`, {
                title: transcript.title,
                is_shared: transcript.is_shared
            }, {
                headers: {
                    Authorization: token
                },
            });
    }
}
export default new TranscriptService();